(function () {
  "use strict";

  function initializeMegaBundlePage() {
    var page =
      document.querySelector(".nmb-page");

    if (!page) {
      return;
    }


    /* ==========================================
       COUNTDOWN

       September 24, 2026
       11:59:59 PM New York time
       September is EDT: UTC-04:00
    ========================================== */

    var launchDeadline =
      new Date("2026-09-24T23:59:59-04:00").getTime();

    var countdown =
      page.querySelector("#nmb-countdown");

    var daysElement =
      page.querySelector("#nmb-days");

    var hoursElement =
      page.querySelector("#nmb-hours");

    var minutesElement =
      page.querySelector("#nmb-minutes");

    var secondsElement =
      page.querySelector("#nmb-seconds");

    var countdownInterval = null;

    function formatCountdownNumber(number) {
      return String(number).padStart(2, "0");
    }

    function showCountdownEnded() {
      if (!countdown) {
        return;
      }

      countdown.innerHTML =
        '<span class="nmb-countdown-ended">' +
        "Launch offer ended" +
        "</span>";

      countdown.setAttribute(
        "aria-label",
        "The launch offer has ended"
      );

      if (countdownInterval) {
        window.clearInterval(countdownInterval);
      }
    }

    function updateCountdown() {
      if (
        !countdown ||
        !daysElement ||
        !hoursElement ||
        !minutesElement ||
        !secondsElement
      ) {
        return;
      }

      var remaining =
        launchDeadline - Date.now();

      if (remaining <= 0) {
        showCountdownEnded();
        return;
      }

      var day =
        1000 * 60 * 60 * 24;

      var hour =
        1000 * 60 * 60;

      var minute =
        1000 * 60;

      var days =
        Math.floor(remaining / day);

      var hours =
        Math.floor(
          (remaining % day) / hour
        );

      var minutes =
        Math.floor(
          (remaining % hour) / minute
        );

      var seconds =
        Math.floor(
          (remaining % minute) / 1000
        );

      daysElement.textContent =
        formatCountdownNumber(days);

      hoursElement.textContent =
        formatCountdownNumber(hours);

      minutesElement.textContent =
        formatCountdownNumber(minutes);

      secondsElement.textContent =
        formatCountdownNumber(seconds);

      countdown.setAttribute(
        "aria-label",
        days +
        " days, " +
        hours +
        " hours, " +
        minutes +
        " minutes, and " +
        seconds +
        " seconds remaining"
      );
    }

    if (
      countdown &&
      daysElement &&
      hoursElement &&
      minutesElement &&
      secondsElement
    ) {
      updateCountdown();

      if (launchDeadline > Date.now()) {
        countdownInterval =
          window.setInterval(
            updateCountdown,
            1000
          );
      }
    }


    /* ==========================================
       BOTTOM PREVIEW CAROUSEL
    ========================================== */

    var carousel =
      page.querySelector(
        "[data-preview-carousel]"
      );

    if (carousel) {
      var track =
        carousel.querySelector(
          "[data-preview-track]"
        );

      var slides =
        Array.prototype.slice.call(
          carousel.querySelectorAll(
            "[data-preview-slide]"
          )
        );

      var dots =
        Array.prototype.slice.call(
          carousel.querySelectorAll(
            "[data-preview-dot]"
          )
        );

      var previousButton =
        carousel.querySelector(
          "[data-preview-previous]"
        );

      var nextButton =
        carousel.querySelector(
          "[data-preview-next]"
        );

      var currentSlide = 0;
      var touchStartX = 0;
      var touchStartY = 0;

      function showSlide(index) {
        if (!track || !slides.length) {
          return;
        }

        if (index < 0) {
          index = slides.length - 1;
        }

        if (index >= slides.length) {
          index = 0;
        }

        currentSlide = index;

        track.style.transform =
          "translateX(-" +
          currentSlide * 100 +
          "%)";

        dots.forEach(function (dot, dotIndex) {
          var isActive =
            dotIndex === currentSlide;

          dot.classList.toggle(
            "is-active",
            isActive
          );

          dot.setAttribute(
            "aria-pressed",
            isActive ? "true" : "false"
          );
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener(
          "click",
          function () {
            showSlide(
              Number(
                dot.getAttribute(
                  "data-preview-dot"
                )
              )
            );
          }
        );
      });

      if (previousButton) {
        previousButton.addEventListener(
          "click",
          function () {
            showSlide(currentSlide - 1);
          }
        );
      }

      if (nextButton) {
        nextButton.addEventListener(
          "click",
          function () {
            showSlide(currentSlide + 1);
          }
        );
      }

      carousel.addEventListener(
        "keydown",
        function (event) {
          if (event.key === "ArrowRight") {
            event.preventDefault();
            showSlide(currentSlide + 1);
          }

          if (event.key === "ArrowLeft") {
            event.preventDefault();
            showSlide(currentSlide - 1);
          }

          if (event.key === "Home") {
            event.preventDefault();
            showSlide(0);
          }

          if (event.key === "End") {
            event.preventDefault();
            showSlide(slides.length - 1);
          }
        }
      );

      carousel.addEventListener(
        "touchstart",
        function (event) {
          touchStartX =
            event.changedTouches[0].clientX;

          touchStartY =
            event.changedTouches[0].clientY;
        },
        {
          passive: true
        }
      );

      carousel.addEventListener(
        "touchend",
        function (event) {
          var touchEndX =
            event.changedTouches[0].clientX;

          var touchEndY =
            event.changedTouches[0].clientY;

          var horizontalDistance =
            touchEndX - touchStartX;

          var verticalDistance =
            touchEndY - touchStartY;

          if (
            Math.abs(horizontalDistance) < 45 ||
            Math.abs(horizontalDistance) <=
            Math.abs(verticalDistance)
          ) {
            return;
          }

          if (horizontalDistance < 0) {
            showSlide(currentSlide + 1);
          } else {
            showSlide(currentSlide - 1);
          }
        },
        {
          passive: true
        }
      );

      showSlide(0);
    }


    /* ==========================================
       LIGHTBOX
    ========================================== */

    var lightbox =
      page.querySelector("#nmb-lightbox");

    var lightboxImage =
      page.querySelector("#nmb-lightbox-image");

    var closeButton =
      page.querySelector("[data-lightbox-close]");

    var imageButtons =
      page.querySelectorAll(
        "[data-lightbox-image]"
      );

    var previouslyFocusedElement = null;

    function openLightbox(button) {
      if (!lightbox || !lightboxImage) {
        return;
      }

      var image =
        button.querySelector("img");

      var fullImage =
        button.getAttribute(
          "data-full-image"
        );

      if (!fullImage && image) {
        fullImage =
          image.currentSrc || image.src;
      }

      if (!fullImage) {
        return;
      }

      previouslyFocusedElement =
        document.activeElement;

      lightboxImage.src =
        fullImage;

      lightboxImage.alt =
        image ? image.alt : "Product preview";

      lightbox.classList.add(
        "is-active"
      );

      lightbox.setAttribute(
        "aria-hidden",
        "false"
      );

      document.body.style.overflow =
        "hidden";

      if (closeButton) {
        closeButton.focus();
      }
    }

    function closeLightbox() {
      if (!lightbox || !lightboxImage) {
        return;
      }

      lightbox.classList.remove(
        "is-active"
      );

      lightbox.setAttribute(
        "aria-hidden",
        "true"
      );

      document.body.style.overflow =
        "";

      lightboxImage.src =
        "";

      if (
        previouslyFocusedElement &&
        typeof previouslyFocusedElement.focus ===
          "function"
      ) {
        previouslyFocusedElement.focus();
      }
    }

    imageButtons.forEach(function (button) {
      button.addEventListener(
        "click",
        function () {
          openLightbox(button);
        }
      );
    });

    if (closeButton) {
      closeButton.addEventListener(
        "click",
        closeLightbox
      );
    }

    if (lightbox) {
      lightbox.addEventListener(
        "click",
        function (event) {
          if (
            event.target === lightbox ||
            event.target === lightboxImage ||
            event.target.classList.contains(
              "nmb-lightbox-content"
            )
          ) {
            closeLightbox();
          }
        }
      );
    }

    document.addEventListener(
      "keydown",
      function (event) {
        if (
          event.key === "Escape" &&
          lightbox &&
          lightbox.classList.contains(
            "is-active"
          )
        ) {
          closeLightbox();
        }
      }
    );


    /* ==========================================
       FAQ
    ========================================== */

    var faqItems =
      page.querySelectorAll(
        ".nmb-faq-item"
      );

    faqItems.forEach(function (item) {
      item.addEventListener(
        "toggle",
        function () {
          if (!item.open) {
            return;
          }

          faqItems.forEach(function (otherItem) {
            if (otherItem !== item) {
              otherItem.open = false;
            }
          });
        }
      );
    });


    /* ==========================================
       UTM TRACKING
    ========================================== */

    var currentParameters =
      new URLSearchParams(
        window.location.search
      );

    var trackingKeys = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term"
    ];

    trackingKeys.forEach(function (key) {
      var value =
        currentParameters.get(key);

      if (!value) {
        return;
      }

      try {
        sessionStorage.setItem(
          "nmb_" + key,
          value
        );
      } catch (error) {
        /* Storage may be unavailable. */
      }
    });

    var checkoutLinks =
      page.querySelectorAll(
        "[data-mega-checkout]"
      );

    checkoutLinks.forEach(function (link) {
      link.addEventListener(
        "click",
        function () {
          var checkoutUrl =
            link.getAttribute("href");

          if (
            !checkoutUrl ||
            checkoutUrl.indexOf("REPLACE_") === 0
          ) {
            return;
          }

          try {
            var url =
              new URL(
                checkoutUrl,
                window.location.origin
              );

            trackingKeys.forEach(function (key) {
              var value =
                currentParameters.get(key);

              if (!value) {
                value =
                  sessionStorage.getItem(
                    "nmb_" + key
                  );
              }

              if (value) {
                url.searchParams.set(
                  key,
                  value
                );
              }
            });

            link.href =
              url.toString();
          } catch (error) {
            /* Keep original checkout URL. */
          }
        }
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeMegaBundlePage
    );
  } else {
    initializeMegaBundlePage();
  }
})();
